"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const decorators_js_1 = require("lit/decorators.js");
const lit_1 = require("lit");
const lit_html_1 = require("lit-html");
const control_1 = require("./control");
/**
 * Чекбокс
 */
let RadioField = class RadioField extends lit_1.LitElement {
    /**
     * Конструктор
     */
    constructor() {
        super();
        /**
         * Значения
         */
        this.values = {};
        this.onChange = this.onChange.bind(this);
    }
    /**
     * Устанавливает корень структуры
     */
    createRenderRoot() {
        return this;
    }
    /**
     * Обрабатывает изменения элемента
     */
    onChange(e) {
        var _a;
        (_a = this.control) === null || _a === void 0 ? void 0 : _a.setValue(e.target.value);
    }
    /**
     * Возвращает значения в необходимом для генерации отображения формате
     */
    getValuesMap() {
        return Object.keys(this.values).reduce((carry, key) => {
            // @ts-ignore
            carry.push({ key: key, value: this.values[key] });
            return carry;
        }, []);
    }
    /**
     * Возвращает представление
     */
    render() {
        return (0, lit_html_1.html) `
            ${this.getValuesMap().map((value, key) => {
            var _a;
            return (0, lit_html_1.html) `
                <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio${key}" value="${value.key}" ?checked="${value.key === ((_a = this.control) === null || _a === void 0 ? void 0 : _a.getValue())}" @click="${this.onChange}">
                    <label class="form-check-label" for="inlineRadio${key}">${value.value}</label>
                </div>
            `;
        })}
        `;
    }
};
__decorate([
    (0, decorators_js_1.property)({ type: control_1.Control }),
    __metadata("design:type", control_1.Control)
], RadioField.prototype, "control", void 0);
__decorate([
    (0, decorators_js_1.property)(),
    __metadata("design:type", Object)
], RadioField.prototype, "values", void 0);
RadioField = __decorate([
    (0, decorators_js_1.customElement)('art-radio-field'),
    __metadata("design:paramtypes", [])
], RadioField);
